module.exports = __webpack_public_path__ + "img/login-chillogallo.92c86d32.svg";